import createElementChangeListener from "../../elementChangeListener.js";
import createSmartIntersector from "../../utils/createSmartIntersector";
import { LIFECYCLE_HACKS, THREADS_PATH } from "../../utils/loadExternalScript.js";
import * as mediaPool from "./_mediaPool";
import { controlSpacer } from "./utils";

const threadsClass = "text-post-media";
const lazyThreadsClass = "lazy-text-post-media";

const activeThreadRequests = [];

function onIntersect(entry) {
    const target = entry.target;

    function onFreeSlot(resourceID) {
        function onFrame(frame) {
            function release() {
                const container = target.closest(".rm-embed-container.rm-loading");

                if (container) {
                    container.classList.remove("rm-loading");
                    container.classList.add("rm-loaded");

                    setTimeout(() => {
                        controlSpacer(frame, container);
                    }, 500);
                }

                mediaPool.release(resourceID);
                observer.disconnect();
            }

            frame.addEventListener("load", release, { passive: true });
            setTimeout(release);
        }

        target.classList.add(threadsClass);
        target.classList.remove(lazyThreadsClass);
        LIFECYCLE_HACKS[THREADS_PATH]?.lib.Embeds.process();

        const observer = createElementChangeListener("iframe", onFrame, true, target);

        activeThreadRequests.push(resourceID);
    }
    mediaPool.request(1700).then(onFreeSlot);
}

function invalidate(element) {
    element.classList.remove(threadsClass);
    element.classList.add(lazyThreadsClass);
}

function beforeDependencyLoad() {
    document.querySelectorAll("blockquote.text-post-media").forEach(invalidate);
}

export default function loadLazyThreads(intersectionObserverProvider) {
    createSmartIntersector(intersectionObserverProvider, {
        onIntersect,
        beforeDependencyLoad,
        onAppear: invalidate,
        initialThreshold: 300,
        selector: "blockquote.text-post-media,blockquote.lazy-text-post-media",
        dependencySrc: THREADS_PATH,
    });
}
